import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu,FiSun}=FiIcons;

const MobileHeader=({onOpenMenu,currentPage})=> {
  const getPageTitle=()=> {
    switch (currentPage) {
      case 'dashboard': return 'Dashboard';
      case 'plants': return 'Anlagen verwalten';
      case 'environmental': return 'Umweltauswirkungen';
      case 'inverter-checks': return 'WR-Prüfungen';
      case 'email-tests': return 'E-Mail Tests';
      default: return 'Dashboard';
    }
  };

  return (
    <motion.div 
      initial={{y: -20,opacity: 0}} 
      animate={{y: 0,opacity: 1}} 
      className="bg-white shadow-sm px-4 py-3 flex items-center justify-between md:hidden"
    >
      <button 
        onClick={onOpenMenu} 
        className="p-2 rounded-lg text-gray-700 hover:bg-gray-100"
      >
        <SafeIcon icon={FiMenu} className="text-xl" />
      </button>
      <div className="flex items-center space-x-2">
        <div className="bg-gradient-to-r from-solar-400 to-solar-600 w-8 h-8 rounded-lg flex items-center justify-center">
          <SafeIcon icon={FiSun} className="text-white text-sm" />
        </div>
        <h1 className="text-lg font-bold text-gray-900">{getPageTitle()}</h1>
      </div>
      <div className="w-8"></div> {/* Empty div for balanced layout */}
    </motion.div>
  );
};

export default MobileHeader;